<template>
  <div :aria-label="$t('app.header_core')" class="header dark:bg-darkblue hidden lg:flex border-b border-solid border-gray-10/50 dark:border-darkblue-600">
    <div class="brand w-full lg:w-72 lg:min-w-aside flex items-center justify-center select-none">
      <router-link :to="{ name: 'login' }">
        <base-logo 
          :filename="logo"
          :apiImage="true"
          :alt="$t('app.base_logo')"
          class="max-h-13"
          data-v-step="0"/>
      </router-link>
    </div>
    <div class="w-full flex items-center justify-between responsive-spacing-y px-10  select-none">
      <div class="flex gap-4 ml-auto text-primary bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 dark:hover:bg-darkblue-600 rounded-xl hover:text-primary-800 dark:hover:text-primary-800">
        <div class="relative z-2010">
          <base-button-responsive type="button" icon="ia-mode" force-icon :text="$t('app.ai')" mode="primary-phantom" @click="toggleChatbotDialog" />
          <span v-show="actualFilterIAMenu" class='badge badge-warning absolute top-2 left-2 z-20 badge-count-visited'
            v-popover:popoverIAMode>
            <base-icon name="filter" size="xs" />
          </span>
          <el-popover ref="popoverIAMode" placement="bottom" width="320" trigger="hover"
            popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200">
            <div>
              <div v-if="actualFilterIAMenu">
                <div class="flex items-center justify-between">
                  <span class="text-lg">{{$t('app.client_filter')}}</span>
                  <base-button-icon @click="resetIAMenuFilter()" name="cross" iconSize="xs" size="xs"
                    mode="primary-phantom"
                    class="ml-2 bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full" />
                </div>
                <div class="flex items-center justify-between">
                  <span>{{ actualFilterIAMenu.idCliente }} - {{ actualFilterIAMenu.Nombre }}</span>
                </div>
              </div>
              <div v-else>
                <span>{{$t('app.empty_client_filter')}}</span>
              </div>
            </div>
          </el-popover>
        </div>
      </div>
      <div class="flex items-center ml-auto">
        <div class="global-tools h-11 flex items-center space-x-2 mr-4">
          <div v-if="!(isRoleUserConsulta || isRoleProvider) && (hasModuleInterfazEmision || hasModuleInvoiceOrVerifactu)" class="relative z-2010">
            <div ref="more"
              class="relative dropdown-area" :class="menuClass">
              <base-button-icon type="button" name="plus" mode="core" :label="$t('invoices.dialogs.open_invoice_menu')" :aria-label="$t('invoices.dialogs.open_invoice_menu')" @click="toggleinvoiceMenu" aria-haspopup="true" aria-controls="overlay_menu" />
              <TieredMenu ref="invoice-menu" id="overlay_menu" :model="invoiceMenu" popup />
            </div>
            <span v-show="actualFilterIMenu" class='badge badge-warning absolute top-2 left-2 z-20 badge-count-visited'
              v-popover:popoverIssuing>
              <base-icon name="filter" size="xs" />
            </span>
            <el-popover ref="popoverIssuing" placement="bottom" width="320" trigger="hover"
              popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200">
              <div>
                <div v-if="actualFilterIMenu">
                  <div class="flex items-center justify-between">
                    <span class="text-lg">{{$t('app.client_filter')}}</span>
                    <base-button-icon @click="resetIMenuFilter()" name="cross" iconSize="xs" size="xs"
                      mode="primary-phantom"
                      class="ml-2 bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full" />
                  </div>
                  <div class="flex items-center justify-between">
                    <span>{{ actualFilterIMenu.idCliente }} - {{ actualFilterIMenu.Nombre }}</span>
                  </div>
                </div>
                <div v-else>
                  <span>{{$t('app.empty_client_filter')}}</span>
                </div>
              </div>
            </el-popover>
          </div>
          <div ref="dashboard" class="relative dropdown-area">
            <div class="relative" @click="gotoDashboard()">
              <base-button-icon name="dashboard" mode="core" />
            </div>
          </div>
          <div ref="notifications" v-outside:click="{ exclude: ['notifications'], handler: closeNotifications }"
            class="relative dropdown-area">
            <div class="relative" @click="toggleNotifications">
              <base-button-icon name="bell" mode="core" />
              <span v-if="announcements !== null && announcements.length > 0" class='badge badge-warning absolute top-2 right-0 z-20' :class="alreadyVisited ? 'badge-count-visited' : 'badge-count'"> {{ $n(total, 'integer') }} </span>
              <span v-show="actualFilterAlerts" class='badge badge-warning absolute top-2 left-2 z-20 badge-count-visited'
                v-popover:popover>
                <base-icon name="filter" size="xs" />
              </span>
              <el-popover ref="popover" placement="bottom" width="320" trigger="hover"
                popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200">
                <div>
                  <div v-if="actualFilterAlerts">
                    <div class="flex items-center justify-between">
                      <span class="text-lg">{{$t('app.client_filter')}}</span>
                      <base-button-icon @click="resetAlertsFilter()" name="cross" iconSize="xs" size="xs"
                        mode="primary-phantom"
                        class="ml-2 bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full" />
                    </div>
                    <div class="flex items-center justify-between">
                      <span>{{ actualFilterAlerts.idCliente }} - {{ actualFilterAlerts.Nombre }}</span>
                    </div>
                  </div>
                  <div v-else>
                    <span>{{$t('app.empty_client_filter')}}</span>
                  </div>
                </div>
              </el-popover>
            </div>
            <base-drop-down :isOpen="nots" position="bottom-right" customClass="w-50 z-2010imp" autoClose
              @toggle="toggleNotifications">
              <div class="p-4">
                <div v-if="announcements != null && announcements.length > 0">
                  <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row" v-for="(announcement, index) in announcements"
                    :key="index">
                    <div class="px-2 w-full  mb-2 lg:mb-0">
                      <router-link v-if="announcement.Enlace !== null" :to="{ name: announcement.Enlace }" href="#"
                        class="child w-full flex items-center  pr-4 h-8
                            hover:bg-primary-100 dark:hover:bg-darkblue-900 active:bg-primary-200 group animate-hover rounded">
                        <span
                          class="cover-subnav w-full overflow-hidden pl-2 flex h-full border-l-2 border-solid items-center dark:border-darkblue-600">
                          <span class="link-name mr-4 truncate group-hover:text-primary dark:text-secondary-200">{{
                            announcement.Mensaje }}</span>
                        </span>
                      </router-link>
                      <div v-else-if="announcement.Accion !== null" @click="onclickAnnouncement(announcement.Accion)"
                        class="child w-full flex items-center pr-4 h-8 cursor-pointer hover:bg-primary-100 dark:hover:bg-darkblue-900 active:bg-primary-200 group animate-hover rounded">
                        <span class="cover-subnav w-full overflow-hidden pl-2 flex h-full border-l-2 border-solid items-center dark:border-darkblue-600">
                          <span class="link-name mr-4 truncate group-hover:text-primary dark:text-secondary-200">{{ announcement.Mensaje }}</span>
                        </span>
                      </div>
                      <span v-else class="cover-subnav w-full overflow-hidden pl-2 flex h-full border-l-2 border-solid items-center dark:text-secondary-200 dark:border-darkblue-600">{{ announcement.Mensaje }}</span>
                    </div>
                    <div class="px-2 mt-1 mb-2 lg:mb-0">
                      <span v-if="announcement.NumeroAvisos !== 0"
                        class='badge badge-warning right-0 z-20 cart-count active:bg-primary-200'>
                        {{ $n(announcement.NumeroAvisos, 'integer') }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="flex items-center justify-center w-32 dark:text-secondary-200" v-else>
                  <p>{{ $t('avisos.announcements_empty') }}</p>
                </div>
              </div>
            </base-drop-down>
          </div>
        </div>
        <div ref="avatar"
            v-outside:click="{ exclude: ['avatar'], handler: closeAvatar }"
            class="relative dropdown-area z-2010">
          <base-avatar 
            :isOpen="avatar" 
            @toggleAvatar="toggleAvatar"
            :custom="['hover:bg-primary-50', { 'bg-primary-50': avatar }, 'dark:bg-darkblue-800', 'dark:hover:bg-darkblue-600', 'dark:text-darkblue-200']" />
          <base-drop-down 
            autoClose 
            :isOpen="avatar" 
            position="bottom-right" 
            @toggle="toggleAvatar">
            <ul class="p-1 divide-y divide-gray-100 dark:divide-gray-800 dark:border-darkblue-600 cursor-pointer">
              <li>
                <button @click="changeDarkMode()" class="capitalize cursor-pointer group flex rounded-md items-center w-full px-2 py-2 text-sm bg-white dark:bg-darkblue dark:text-darkblue-200 lg:dark:bg-darkblue-900 hover:bg-primary-50 dark:hover:bg-darkblue hover:text-primary active:bg-primary-100 dark:active:bg-darkblue-600 dark:focus:bg-darkblue-600 dark:focus:text-primary">
                  <base-icon name="darktheme" class="mr-2" aria-hidden/>
                  {{ mode }}
                </button>
              </li>
              <base-link-item-nav v-for="option in userOptions" :option="option" :key="option.name" />
            </ul>
          </base-drop-down>
        </div>
      </div>
    </div>
    <help-dialog :dialogOpen="helpDialogOpen" @toggleDialog="toggleDialog" />
    <upload-issued-invoice-dialog :dialogOpen="uploadIssuedInvoiceDialog" @toggleDialog="toggleUploadIssuedInvoice"
      @applyDialog="applyUploadInvoice" />
    <upload-received-invoice-dialog :dialogOpen="uploadReceivedInvoiceDialog" @toggleDialog="toggleUploadReceivedInvoice"
      @applyDialog="applyUploadInvoice" />
    <upload-verifactu-dialog :dialogOpen="uploadVerifactuDialog" @toggleDialog="toggleUploadVerifactu"
      @applyDialog="applyUploadInvoice" />
    <UploadInvoicesProgressDialog 
      :dialogOpen="uploadInvoiceProgressData.isOpen" :params="uploadInvoiceProgressData" 
      :recibidas="uploadInvoiceProgressData.recibidas" @toggleDialog="toggleUploadProgressInvoice"
      @applyDialog="applyUploadProgressInvoice" @resetDialog="resetUploadProgressInvoice" />
  </div>
</template>

<script>
import { bus } from '@/main'
import { i18n } from '@/i18n'
import { v4 as uuidv4 } from 'uuid'
import HelpDialog from '@/components/HelpDialog.vue'
// import LicenseDialog from '@/components/LicenseDialog.vue'
import UploadIssuedInvoiceDialog from '@/components/uploadinvoice/UploadIssuedInvoiceDialog.vue'
import UploadReceivedInvoiceDialog from '@/components/uploadinvoice/UploadReceivedInvoiceDialog.vue'
import UploadVerifactuDialog from '@/components/uploadinvoice/UploadVerifactuDialog.vue'
import UploadInvoicesProgressDialog from '@/components/uploadinvoice/UploadInvoicesProgressDialog.vue'
import { setTransitionAllowed } from '@/services/functions/modeAllowedTransitionHelper'

export default {
  name: 'header-core',
  components: {
    HelpDialog,
    UploadIssuedInvoiceDialog,
    UploadReceivedInvoiceDialog,
    UploadVerifactuDialog,
    UploadInvoicesProgressDialog,
  },
  mounted () {
    this.$root.$on('openNotesPatch', () => {
      this.showHelp()
      // Esperamos un poco para que se nota que el salto es a proposito
      setTimeout(() => {
        this.clickPatchNotes()
      }, 500)
    })
  },
  data: function () {
    return {
      uploadIssuedInvoiceDialog: false,
      uploadReceivedInvoiceDialog: false,
      uploadVerifactuDialog: false,
      helpDialogOpen: false,
      nots: false,
      alreadyVisited: false,
      total: 0,
      avatar: false,
      uuidList: [],
      productSelect: [
      ],
      configOptions: [
      ],
      uploadInvoiceProgressData: {
        isOpen: false,
        idCliente: 0,
        idCIFEmpresa: 0,
        pgeType: null,
        autoSend: false,
        facturas: [],
        recibidas: false,
      },
      uploadingInvoices: false,
      menuLeft: false
    }
  },
  computed: {
    menuClass () {
      return { 'menu-left': this.menuLeft }
    },
    isRoleProvider: function () {
      return this.role === 9
    },
    actualFilterAlerts () {
      return this.$store.getters['app/idClienteFilterAlerts']
    },
    actualFilterIMenu () {
      return this.$store.getters['app/idClienteFilterIMenu']
    },
    actualFilterIAMenu () {
      return this.$store.getters['app/idClienteFilterIAMenu']
    },
    isIssuingCreation: function () {
      return !!this.$store.getters['app/isInMode'](1)
    },
    issuingModeActive: function () {
      return this.isIssuingCreation ? 'primary' : 'core'
    },
    issuingType: function () {
      return this.$store.getters['invoicesIssuing/issuingType']
    },
    issuingOptions: function () {
      return [
        {
          type: 1,
          label: i18n.t('invoices.entity_name'),
          issuingLabel: i18n.t('invoices.invoices_issuing.header'),
          icon: 'pi zc zc-imenu-factura',
          command: this.gotoIssuing
        },
        {
          type: 2,
          label: i18n.t('invoices.invoices_issuing.proforma.entity_name'),
          issuingLabel: i18n.t('invoices.invoices_issuing.proforma.header'),
          icon: 'pi zc zc-imenu-proforma',
          command: this.gotoProforma
        },
        {
          type: 3,
          label: i18n.t('invoices.invoices_issuing.quotation.entity_name'),
          issuingLabel: i18n.t('invoices.invoices_issuing.quotation.header'),
          icon: 'pi zc zc-imenu-presupuesto',
          command: this.gotoQuotation
        },
        {
          type: 4,
          label: i18n.t('invoices.invoices_issuing.simplified.entity_name'),
          issuingLabel: i18n.t('invoices.invoices_issuing.simplified.header'),
          icon: 'pi zc zc-imenu-simplificada',
          command: this.gotoSimplified
        }
      ]
    },
    currentIssuingOption: function () {
      const current = { ...(this.issuingOptions.find(option => option.type === this.issuingType) || this.issuingOptions[0]) }
      current.label = current.issuingLabel
      return this.isIssuingCreation ? current : null
    },
    invoiceMenu: function () {
      const issueMenuItem = this.currentIssuingOption ?? {
        label: i18n.t('invoices.invoices_issuing.issue'),
        icon: 'pi zc zc-imenu-emitir',
        items: this.issuingOptions.map(option => ({
          label: option.label,
          icon: option.icon,
          disabled: option.type === this.issuingType && this.$route.name === 'invoicesissuing',
          command: option.command
        }))
      }
      return ([
        issueMenuItem,
        {
          separator: true
        },
        {
          label: i18n.t('app.upload_document'),
          icon: 'pi zc zc-imenu-subir-documento',
          items: [
            {
              label: i18n.t('invoices.issued_singular_header'),
              icon: 'pi zc zc-imenu-emitida',
              command: this.toggleUploadIssuedInvoice
            },
            {
              label: i18n.t('invoices.received_singular_header'),
              icon: 'pi zc zc-imenu-recibida',
              command: this.toggleUploadReceivedInvoice
            },
            {
              label: i18n.t('verifactu.header'),
              icon: 'pi zc zc-imenu-subir-verifactu',
              command: this.toggleUploadVerifactu
            }
          ]
        },
      ])
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserConsulta: function () {
      return this.role === 4 || this.role === 7
    },
    darkMode: function () {
      return !!this.$store.getters['app/darkMode']
    },
    lcbuttonMode: function () {
      return this.darkMode ? 'dark' : 'light'
    },
    logo: function () {
      const pathBase = process.env.VUE_APP_API_URL + 'api/personalizacion/getrecurso?hash='
      const user = this.$store.getters['auth/user']

      // Personalizacion de logo
      if (user) {
        if (this.darkMode) {
          if (user.HashLogoDark) { 
            return pathBase + user.HashLogoDark 
          }
        } else {
          if (user.HashLogo) {
            return pathBase + user.HashLogo
          }
        }
      }

      // if (this.darkMode) {
      //   return '/logos/logo-invoize-no-edas-dark.png'
      // }
      // return '/logos/logo-invoize-no-edas.png'
      if (this.darkMode) {
        return '/logos/logo-invoize-dark.svg'
      }
      return '/logos/logo-invoize.svg'
    },
    tiposAviso: function () {
      return this.$store.getters['config/TIPOS_AVISO']
    },
    announcements: function () {
      const announcements = []
      const value = this.$store.getters['app/getAnnouncementsList']
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.total = 0
      if (value != null) {
        value.forEach(element => {
          const aviso = this.tiposAviso.find(x => element.TipoAviso === x.TipoAviso)
          element.Mensaje = aviso?.Mensaje ?? element.Mensaje
          announcements.push(element)
          this.total += element.NumeroAvisos
        })
      }
      return announcements
    },
    mode: function () {
      if (this.darkMode === true) {
        return i18n.t('app.mode_light')
      } else {
        return i18n.t('app.mode_dark')
      }
    },
    userOptions: function () {
      const showHelp = this.showHelp
      const activePortalHandler = this.openPortalZohoDialog
      const actions = [
        {
          icon: 'user',
          name: i18n.t('app.user_profile'),
          click: function ({ store }) {
            store.dispatch('auth/me', { navigate: true })
          }
        },
        {
          icon: 'help',
          name: i18n.t('app.help'),
          click: function () {
            showHelp()
          }
        }
      ] 
      if (this.subActionVisible) {
        actions.push({
          icon: 'checkdiscount',
          name: i18n.t('suscription.title_capitalize'),
          click: function () {
            activePortalHandler()
          }
        },)
      }
      actions.push(
        {
          icon: 'logout',
          name: i18n.t('app.logout'),
          click: function ({ store }) {
            store.dispatch('auth/logout')
          }
        })
      return actions
    },
    subActionVisible () {
      return this.hasIntegracionZoho && [1, 2, 4].includes(this.role)
    },
    hasIntegracionZoho () {
      return this.$store.getters['auth/hasIntegracionZoho']
    },
    hasModuleVerifactu: function () { 
      return this.$store.getters['auth/hasVerifactuModule'] 
    },
    hasModuleReceivedInvoice: function () { 
      return this.$store.getters['auth/hasReceivedInvoiceModule'] 
    },
    hasModuleIssuedInvoice: function () { 
      return this.$store.getters['auth/hasIssuedInvoiceModule'] 
    },
    hasModuleInvoiceOrVerifactu: function () {
      return this.hasModuleIssuedInvoice || this.hasModuleReceivedInvoice || this.hasModuleVerifactu
    },
    hasModuleInterfazEmision: function () {
      return !!this.$store.getters['auth/hasInterfazEmisionModule'] && (this.hasModuleIssuedInvoice || this.hasModuleVerifactu)
    },
  },
  watch: {
    $route: 'routerChangeHandler',
    announcements: function (value, oldValue) {
      if (value?.length > oldValue?.length) {
        this.alreadyVisited = false
      }
    }
  },
  methods: {
    resetAlertsFilter () {
      this.$store.dispatch('app/updateidClienteFilterAlerts', null)
      this.$store.dispatch('app/getAnnouncementsList')
    },
    resetIMenuFilter () {
      this.$store.dispatch('app/updateidClienteFilterIMenu', null)
    },
    resetIAMenuFilter () {
      this.$store.dispatch('app/updateidClienteFilterIAMenu', null)
    },
    onclickAnnouncement (action) {
      const data = { filters: [] }
      if (action === 'importacionesError') {
        data.filters.push({ type: 'tipoImportacionEstado', data: { value: 2, label: i18n.t('imports.status') } })
        this.pushRouteNameAux(data, 'configurations/imports')
      } else if (action === 'clientesCertSAML2PorCaducar') { 
        data.filters.push({ type: 'certificadoSAML2PorCaducar', data: { value: true, label: i18n.t('clients.certificadoSAML2PorCaducar_filter') } })
        this.pushRouteNameAux(data, 'configurations/clients')
      } else if (action === 'clientesCertSAML2Caducados') { 
        data.filters.push({ type: 'certificadoSAML2Caducado', data: { value: true, label: i18n.t('clients.certificadoSAML2Caducado_filter') } })
        this.pushRouteNameAux(data, 'configurations/clients')
      }
    },
    pushRouteNameAux (data, name) {
      this.$router.push(
        {
          name: name, 
          params: { data: data }, 
          query: { _r: this.guid() } 
        })
    },
    toggleUploadIssuedInvoice () {
      this.uploadIssuedInvoiceDialog = !this.uploadIssuedInvoiceDialog
    },
    toggleUploadReceivedInvoice () {
      this.uploadReceivedInvoiceDialog = !this.uploadReceivedInvoiceDialog
    },
    toggleUploadVerifactu () {
      this.uploadVerifactuDialog = !this.uploadVerifactuDialog
    },
    closeUploadInvoice () {
      this.uploadIssuedInvoiceDialog = false
      this.uploadReceivedInvoiceDialog = false
      this.uploadVerifactuDialog = false
    },
    
    /**
     * @param {Object} obj 
     * @param {Boolean} obj.background 
     * @param {{blnError: Boolean, codError: String, msgError: String, Respuesta: Boolean}[]?} obj.results
     * @param {{idCliente: Number, idCIFEmpresa: Number, pgeType: String, autoSend: Boolean, facturas: Any[], recibidas: Boolean}} obj.params
     */
    applyUploadInvoice: async function ({ background = false, results = null, params = null }) {
      if (background) {
        this.uploadingInvoices = true
        this.closeUploadInvoice()
      } else if (params?.facturas?.length > 0) {
        this.uploadInvoiceProgressData.idCliente = params.idCliente
        this.uploadInvoiceProgressData.idCIFEmpresa = params.idCIFEmpresa
        this.uploadInvoiceProgressData.pgeType = params.pgeType
        this.uploadInvoiceProgressData.autoSend = params.autoSend
        this.uploadInvoiceProgressData.facturas = params.facturas
        this.uploadInvoiceProgressData.recibidas = params.recibidas
        this.uploadingInvoices = true
        this.closeUploadInvoice()
        this.toggleUploadProgressInvoice()
      } else {
        this.uploadingInvoices = false
        if (results?.length > 0) {
          const success = results.filter(x => !x.blnError)
          const errors = results.filter(x => x.blnError)
          if (errors.length > 0) {
            // TODO: Recargar avisos
            // this.$store.dispatch('app/getAnnouncementsList')

            // TODO: Generar avisos de errores
            const link = 'notices/uploaderrors'
            const aviso = this.$store.dispatch('app/getAnnouncement', { link })
            this.uuidList = aviso?.params?.map(x => x.uuid) ?? []
            errors.forEach(x => this.$set(x, 'uuid', this.generateErrorUuid()))
            this.$store.dispatch('app/updateAnnouncement', { link, NumeroAvisos: errors.length, Mensaje: i18n.t('feedback.error.invoice_upload_error'), params: errors })
          }
          if (success.length > 0) {
            bus.$emit('changeIt', 'changed menu')
          }
        }
      }
    },
    generateErrorUuid: function () {
      var uuid = ''
      do {
        uuid = crypto.randomUUID()
      } while (this.uuidList.includes(uuid))
      return uuid
    },
    toggleUploadProgressInvoice () {
      this.uploadInvoiceProgressData.isOpen = !this.uploadInvoiceProgressData.isOpen
    },
    applyUploadProgressInvoice: async function (data = { progress: [], success: true, background: false }) {
      if (data.background) {
        this.uploadingInvoices = true
        // TODO: Generar avisos de progreso
      } else {
        this.uploadingInvoices = false
        if (!data.success && data.progress.length > 0) {
          // TODO: Eliminar avisos de progreso
          // TODO: Generar avisos de errores
        }
      }
    },
    resetUploadProgressInvoice: function () {
      this.uploadInvoiceProgressData.idCliente = 0
      this.uploadInvoiceProgressData.idCIFEmpresa = 0
      this.uploadInvoiceProgressData.pgeType = null
      this.uploadInvoiceProgressData.autoSend = false
      this.uploadInvoiceProgressData.facturas = []
      this.uploadInvoiceProgressData.recibidas = false
    },
    showHelp: function () {
      this.toggleDialog()
    },
    toggleDialog: function () {
      this.helpDialogOpen = !this.helpDialogOpen
      if (!this.helpDialogOpen) {
        this.$store.dispatch('app/updatelastVisitedPatchNotes')
        this.$root.$emit('setControlFlagPatchNotes')
      }
    },
    openPortalZohoDialog: function () {
      bus.$emit('activePortalZoho')
    },
    routerChangeHandler: function () {
      //
    },
    toggleNotifications: function () {
      this.nots = !this.nots
      this.alreadyVisited = true
    },
    closeNotifications: function () {
      this.nots = false
    },
    toggleAvatar: function () {
      this.avatar = !this.avatar
    },
    closeAvatar: function () {
      this.avatar = false
    },
    toggleinvoiceMenu: function (event) {
      const menu = this.$refs['invoice-menu']
      if (menu) {
        menu.toggle(event)
        if (menu.visible) {
          this.$nextTick(() => {
            const container = menu.$refs.container
            if (!menu.visible || !container) {
              return
            }
            const { right, width } = container.getBoundingClientRect()
            this.menuLeft = document.documentElement.clientWidth - right < width
          })
        }
      }
    },
    toggleChatbotDialog: function (event) {
      this.$emit('toggleChatbotDialog', event)
    },
    changeDarkMode: function () {
      this.$store.commit('app/setDarkMode', !this.darkMode)
    },
    gotoDashboard: function () {
      const uuid = this.guid()
      this.$router.push({ name: 'dashboard', params: { id: uuid } })
    },
    gotoIssuing: function () {
      setTransitionAllowed(1, this.isIssuingCreation)
      this.$router.push({ name: 'invoicesissuing', params: { issuingType: 1 } })
    },
    gotoProforma: function () {
      setTransitionAllowed(1, this.isIssuingCreation)
      this.$router.push({ name: 'invoicesissuing', params: { issuingType: 2 } })
    },
    gotoQuotation: function () {
      setTransitionAllowed(1, this.isIssuingCreation)
      this.$router.push({ name: 'invoicesissuing', params: { issuingType: 3 } })
    },
    gotoSimplified: function () {
      setTransitionAllowed(1, this.isIssuingCreation)
      this.$router.push({ name: 'invoicesissuing', params: { issuingType: 4 } })
    },
    guid: function () {
      return uuidv4()
    }
  },
}
</script>

<style lang="scss" scoped>
.w-aside-lg {
  width: 35rem;
}

.z-2010imp {
  z-index: 2010 !important;
}

.open-user-menu {
  &:active {
    transform: scale(0.96);
  }
}

.animate-hover {
  @apply transition-colors duration-300;
}

.badge {
  padding-left: 9px;
  padding-right: 9px;
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
  border-radius: 9px;
}

.label-warning[href],
.badge-warning[href] {
  background-color: #c67605;
}

#lblCartCount {
  font-size: 12px;
  background: #ff0000;
  color: #fff;
  padding: 0 5px;
  vertical-align: top;
  margin-left: -10px;
  margin-top: -15px;
}

.max-width-logo {
  width: 500px;
  max-width: 500px;
}

.cart-count {
  font-size: 16px;
  @apply bg-primary-300;
  @apply dark:bg-primary-500;
  color: #fff;
  padding: 5px 10px;
  vertical-align: center;
  margin-top: -15px;
}

.badge-count {
  font-size: 12px;
  background: #ff0000;
  color: #fff;
  padding: 0 5px;
  vertical-align: top;
  margin-left: -10px;
  margin-top: -15px;
}

.badge-count-visited {
  font-size: 12px;
  @apply bg-primary-800;
  @apply dark:bg-primary-500;
  color: #fff;
  padding: 0 5px;
  vertical-align: top;
  margin-left: -10px;
  margin-top: -15px;
}
</style>
